import { Injectable } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import icons from './icons.data';
import { SvgSanitizerService } from './svg-sanitizer.service';

export type IconType = keyof typeof icons;

@Injectable()
export class IconService {
  constructor(private svgSanitizer: SvgSanitizerService) {}

  /**
   * Return the SVG content for an icon
   * @param name Name of the icon to get the SVG for
   */
  public getSvgForName(name: IconType): string {
    return icons[name];
  }

  /**
   * Return the sanitized SVG content for an icon
   * @param name Name of the icon to get the sanitized SVG for
   */
  public getSanitizedSvgForName(name: IconType): SafeHtml {
    const svgContent = icons[name];
    return this.svgSanitizer.sanitizeSvg(svgContent);
  }
}
